import { render, staticRenderFns } from "./DelDict.vue?vue&type=template&id=53a8b7f2&scoped=true"
import script from "./DelDict.vue?vue&type=script&lang=js"
export * from "./DelDict.vue?vue&type=script&lang=js"
import style0 from "./DelDict.vue?vue&type=style&index=0&id=53a8b7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a8b7f2",
  null
  
)

export default component.exports